module.exports = {
    copy: {},
    lang: '',
    urls:{
	data:"data/data.json",
    },
    units: {
	yearSize: window.innerWidth < 1400 ? 55 : 70,
	monthSize: window.innerWidth < 1400 ? 55 /12 : 70 / 12,
	daySize: window.innerWidth < 1400 ? 55 / 360 : 70 / 360,
	minYear: 1900,
	maxYear: 1970,
	leftMargin: window.innerWidth < 1400 ? 100 : 200,
	color: d3.scaleLinear()
	    .domain([0, 0.4, 1])
	    .range(["rgb(64, 10, 255)", "rgb(255, 12, 228)", "rgb(255, 181, 0)"]),
    },
    _data: {
	master: {},
	nodesData: [],
	linksData: [],
	dates: {},
	yAxis: {},
	datesData:[{year:1900, x:200, timebreak:false}],
	protagonists: {'M': 'Manquilef', 'AP': 'Aburto Panguilef', 'C': 'Coñuepán'}
    },
};
